import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aceites/agenda_facilmente.gif")